@if(isActive) {

@if(!browsersniffer.isPhone()){
<div class="trace-header flex-container container-space-between column " tabindex="-1">
  <h4 class="">{{ "trace.tab-tip-suggestions" | translate }}</h4>
  <div class="list-sub-header">{{ (suggestionsTabTitleI8nKey ? suggestionsTabTitleI8nKey:
    "trace.suggestions-route.title") |
    translate }}</div>
</div>
}
<!--surface-container-lowest  -->
<div class="trace-body column no-footer ">
  <div class="suggestions" id="suggestions">

    @let generalDescForLang= findTextForCurrentLanguage(traceSuggestionsConfigService.configData().description, -1);
    @if (generalDescForLang) {
    <div class="description" [innerHTML]="generalDescForLang"></div>
    }

    @let suggestionsCount = getSuggestionsCount();

    @if(suggestionsCount === 0) {

    <div class="no_suggestions">{{'trace.suggestions-route.no_routes' | translate }}</div>

    } @else if(traceSuggestionsConfigService.configData().add_az_index && suggestionsCount > 2) {

    @if(suggestionsCount > 0 && (traceSuggestionsConfigService.configData().form_options.default_layer.show ||
    traceSuggestionsConfigService.configData().form_options.route_centroids_on_map.show)){

    <mat-card appearance="filled" class="az_index surface-container">
      <mat-card-content>
        <div>
          <!-- class="form_options" -->
          @if(traceSuggestionsConfigService.configData().form_options.default_layer.show){
          @let textForLang =
          findTextForCurrentLanguage(traceSuggestionsConfigService.configData().form_options.default_layer.form_text,
          -1);
          <div class="">
            <mat-slide-toggle aria-label="default_layer" id="default_layer"
              [checked]="traceSuggestionsConfigService.configData().form_options.default_layer.form_checked"
              (change)="this.traceService.changedSuggestionsSetting(true)">{{textForLang}}</mat-slide-toggle>
          </div>
          }
          @if(traceSuggestionsConfigService.configData().form_options.route_centroids_on_map.show){
          @let textForLang =
          findTextForCurrentLanguage(traceSuggestionsConfigService.configData().form_options.route_centroids_on_map.form_text,
          -1);
          <div class="form_option">
            <mat-slide-toggle aria-label="route_centroids_on_map" id="route_centroids_on_map"
              [checked]="traceSuggestionsConfigService.configData().form_options.route_centroids_on_map.form_checked"
              (change)="this.traceService.changedSuggestionsSetting(false)">{{textForLang}}</mat-slide-toggle>
          </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
    }
 <h5 class="mat-title-medium mt-2">Routes</h5>
     <!-- we show an a-z index if there are more than 2 routes -->
    <mat-card appearance="filled" class="az_index surface-container">
      <!--
      <mat-card-header>
        <mat-card-title>A-Z</mat-card-title>
      </mat-card-header>
    -->
      <mat-card-content>
        @for (route of getOrderedConfigDataRoutes('az_index_title',
        true); track route.route_id;
        let idx = $index) {
        @if(route.show){
        @let textForLang = findTextForCurrentLanguage(route.az_index_title, 30);
        <button matButton="text"
          [innerHTML]="textForLang ? textForLang : ('trace.field.noname' | translate) + '('+idx+')' "
          (click)="scrollToSuggestionsItem(route.route_id)"></button>
        }
        }
      </mat-card-content>
    </mat-card>

    }

    @for (route of (traceSuggestionsConfigService.configData().add_az_index ?
    getOrderedConfigDataRoutes('az_index_title', true)
    : getOrderedConfigDataRoutes('title', true) ); track
    route.route_id; let
    idx = $index) {
    @if(route.show){
    <mat-card appearance="filled" [attr.id]="route.route_id" tabindex="-1" class="suggestionsItem mt-2"
      [class.highlight]="highlightedSuggestionItemId() === route.route_id">
      <!--  -->
      <!-- <mat-card appearance="filled" [attr.id]="route.route_id" tabindex="-1" class="suggestionsItem mt-2"
      [class.highlight]="highlightedSuggestionItemId() === route.route_id" (click)="openSuggestionsItem(route.route_id)"
      (mouseenter)="traceService.highlightSuggestionOnMap(route.route_id, true)"
      (mouseleave)="traceService.highlightSuggestionOnMap(route.route_id, false)"> -->
      <mat-card-header class="pt-1 container-space-between">

        <!-- <div mat-card-avatar class=""></div> -->
        <mat-card-title>
          @if (route.preview_image_url) {
          <div 
          (click)="traceService.zoomToSuggestionOnMap(route.route_id)"
            (mouseenter)="traceService.highlightSuggestionOnMap(route.route_id, true)"
            (mouseleave)="traceService.highlightSuggestionOnMap(route.route_id, false)"
             title="{{'trace.suggestions-route.zoom'
            | translate}}"
            style="cursor: pointer;">
            <img mat-card-image src="{{route.preview_image_url}}" alt="preview" />
          </div>
          }
          <div class="content-padder">
            <!-- 'mediumDate' without time, 'medium' with time HH:mm:ss -->
            @if(route.created > 1714000000000){
            <div class="created mat-body-small mt-05">
              {{route.created | date:'mediumDate':'+0100':lang()}}
            </div>
            }
            @let textForLang = findTextForCurrentLanguage(route.title, -1);
            <div [innerHTML]="textForLang ? textForLang : ('trace.field.noname' | translate)+ '('+idx+')'">
            </div>

          </div>

        </mat-card-title>
        <!-- <mat-card-subtitle></mat-card-subtitle> -->
      </mat-card-header>
      <mat-card-content class="routeinfo">
        @let descForLang= findTextForCurrentLanguage(route.description, -1);
        @if (descForLang) {
        <div class="content-padder">
          <div class="walk-description" [innerHTML]="descForLang"></div>
          <!-- <mat-divider></mat-divider> -->
        </div>
        }
        <!-- <div class="preview" [ngClass]="{'hasPreview': historyItem.thumb && historyItem.thumb.length > 0}"><img *ngIf="historyItem.thumb && historyItem.thumb.length > 0" src="{{historyItem.thumb}}" alt="preview" /></div> -->
        <div class="routeData mb-1 mt-05  content-padder">
          <a title="{{'trace.total-distance' | translate}}">
            <mat-icon fontSet="ngi" fontIcon="measure"></mat-icon>
            <!--  -->
            <span [innerHTML]="formatRouteDistance(route.dist >= 0 ? route.dist : -1, false)"></span>
            &nbsp;
          </a>
          <a title="{{'trace.total-height' | translate}}" style="padding-right: 0px;padding-left:10px">
            <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
            &nbsp;<span [innerHTML]="formatRouteDistance(route.upwardDist >= 0 ? route.upwardDist : -1, true)"></span>
          </a>

          <!-- todo time ? -->
          <a title="{{'trace.walk-time' | translate}}" style="padding-right: 0px;padding-left:10px">
            <mat-icon>schedule</mat-icon>
            &nbsp;<span [innerHTML]="formatRouteTime(route.time >= 0 ? route.time : -1)"></span>
          </a>
        </div>


        <div class="routeData mb-1 mt-05  content-padder">
          <a matButton="" class="ngi-green-blue-button" (click)="traceService.zoomToSuggestionOnMap(route.route_id)"
            (mouseenter)="traceService.highlightSuggestionOnMap(route.route_id, true)"
            (mouseleave)="traceService.highlightSuggestionOnMap(route.route_id, false)">{{'trace.suggestions-route.zoom'
            | translate}}</a>
          <a matButton="tonal" class="ngi-green-blue-button"
            (click)="traceService.openSuggestionsRoute(route.route_id, false)"
            (mouseenter)="traceService.highlightSuggestionOnMap(route.route_id, true)"
            (mouseleave)="traceService.highlightSuggestionOnMap(route.route_id, false)">{{'general.open' |
            translate}}</a>
        </div>

      </mat-card-content>

    </mat-card>
    }
    }

  </div>
</div>
}